// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import limit from './api/limit'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import '@wangeditor/editor/dist/css/style.css'


Vue.config.productionTip = false
Vue.use(ElementUI,axios)
Vue.prototype.$limit = limit
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js